import store from 'src/store'

/**
 * Checa se a empresa esta habilitada para usar as apis
 * refatoradas da folha (dia-da-folha) e não usar as apis segmentadas (djs, pts, justifies etc)
 * @returns {boolean}
 */
export const empresaUsaApisRefatoracaoFolha = () => {
  return store.state.modulosEFuncionalidades.funcionalidades.acesso_refatoracao_folha?.enabled || false
}
